const zIndices = {
  hide: -1,
  auto: 'auto',
  base: 0,
};

export type ZIndices = typeof zIndices;

export default zIndices;
